import { AppState } from 'src/store';

const selectReadNotifications = (state: AppState) => state.notifications.read;

export const notificationsSelectors = {
  selectReadNotifications,
};
